import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'inc-modal-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() color: string;
  @Input() label: string;
  @Input() mode: string;
  @Output() onRefresh: EventEmitter<void> = new EventEmitter();

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  close() {
    this.modalController.dismiss();
  }

  refresh() {
    this.onRefresh.emit();
  }

  isRefresh() {
    return this.mode === 'Modify';
  }
}
